module.exports = __webpack_public_path__ + "static/media/pic9.9ca6a857.jpg";